import React from 'react';
import './loading_modal.scss';

const LoadingModal = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <div className="loading-modal-overlay">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default LoadingModal;
